import Base from './base/index';

const MailBoxService = {};

export default {
  ...Base,
  ...MailBoxService,
};
